/**
 * # useReducedMotion
 * Detect the prefers-reduced-motion setting
 *
 * @example
 * useReducedMotion(false, "click")
 *
 * @param {boolean} defaultVal - accepts a default value and if the media query is not available the default remains
 * @param {string} listener - pass in event listener
 *
 */

import { useState, useEffect } from "react";

const useReducedMotion = (defaultVal = true, listener = "change") => {
  const [reducedMotion, setReducedMotion] = useState(defaultVal);

  // Callback for media query change events
  function queryChangeHandler(event) {
    // Set state to the value of the media query
    setReducedMotion(event.target.matches);
  }

  useEffect(() => {
    if (typeof window === "undefined") return;

    // Get the reduced motion media query
    const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");

    if (mediaQuery) {
      // Set state to the value of the media query
      setReducedMotion(mediaQuery.matches);

      // Listen for changes in the media query
      mediaQuery.addEventListener(listener, queryChangeHandler);

      return () => mediaQuery.removeEventListener(listener, queryChangeHandler);
    }
  }, [listener]);

  return reducedMotion;
};

export default useReducedMotion;
